import * as React from "react";
import {Currency} from "../../../../../../../config/currencies";
import {MoneyField} from "../../../../../../Components/Form/MoneyField";

interface ISplitMethodFixedFieldProps {
    value: string;
    onChange(rawValue: string, value: number): void;
    originalCurrency: Currency;
    errors?: any;
}

export const SplitMethodFixedField = ({value, onChange, originalCurrency, errors}: ISplitMethodFixedFieldProps) => (
    <MoneyField
        value={value}
        currency={originalCurrency}
        onChange={onChange}
        errors={errors}
    />
);
